


























































































































Currency = require 'models/currency.coffee'

module.exports =
  name: 'payment'
  metaInfo:
    title: '❤️'
    script:
      { type: 'text/javascript', src: 'https://js.stripe.com/v2/' }
  data: ->
    payment_mode:  'stripe'
    prices:        @$store.state.user.prices
    loading:       false
    success_modal: false
    error_modal:   false
  computed:
    rub_price: -> (usd) -> _.round(Currency.convert(usd, 'usd', 'rub') * 1.1, -1) # 10% markup
  mounted: ->
    HM.track("page-payment", { days_till_end: HM.store.getters.days_till_end })
    $('.stripe_script').each (_, el) ->
      script = $( $(el).html().replace(/div/g, 'script') )
      $(el).html script
  methods:
    classes: (months) -> 'payment-highlighted' if months == 12
    openStripe: (months) ->
      handler = StripeCheckout.configure
        key: 'pk_live_zAGpenpvVkSEZv2idGZovHl4' # hmbee.ru code
        image: require('assets/bees/round_thumbs_up.png')
        locale: 'auto'
        amount: @prices[months]*100
        currency: "usd"
        name: 'ХаниМани'
        email: @$store.state.user.userdata.email
        description: "Доступ на #{months} мес"
        panelLabel: 'Заплатить'
        token: (token) =>
          @loading = true
          promise = HM_API.create_payment(months, token.id)
          promise.then (res) =>
            @loading = false
            if res.status == 'success'
              HM.track "user-paid", { months: months, price: @prices[months], days_till_end: HM.store.getters.days_till_end }
              HM.store.state.user.userdata.paid_till = res.data.paid_till
              @success_modal = true
            if res.status == 'failure'
              @error_modal = true
              @error = res.error
          promise.catch =>
            @loading = false
            @error_modal = true
      handler.open()
    yoomoney_button_src: (months) ->
      email = HM.store.state.user.userdata.email
      sum = @rub_price(@prices[months])
      description = "HoneyMoney #{months} мес. (#{email})"
      return "https://yoomoney.ru/quickpay/button-widget?targets=#{description}&default-sum=#{sum}&button-text=11&any-card-payment-type=on&button-size=s&button-color=orange&mail=on&successURL=https%3A%2F%2Fhmbee.ru%2Fru%2Fspasibo%2F&quickpay=small&account=41001208121737"

